const FormResources = {

    form_data:{
        building_id:        '',
        level_id:           '',
        area_id:            '',
        description:        '',
        custom_description: '',
        second_description: '',
        task_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        closed:               '',
        door_number:        '',

        fixture_simbol:     1,
        fixtures:           '',

        sq_ft_simbol:       1,
        sq_ft:              '',

        essential_cleaning: '',
        work_group:         '',
        exclude_daily:      '',
        exclude_project:    '',
        patient:            '',

        freq_simbol:        1,
        frequency:          '',

        notes:              '',
        disabled_daily:     '',
        disabled_project:   '',

        radio:              'all',
        daily_assignment_id: '',


        time_adjustment_simbol:       1,
        time_adjustment:              '',

        shift1:             false,
        shift2:             false,
        shift3:             false,
        none:               false,
    },

}

export default FormResources